<template>
  <ion-page class="directory-page">
    <ion-content class="">
      <div class="header">
        <div class="title-container">
          <div class="page-title">目录</div>
          <img class="page-title-shadow" src="@/assets/grammar/contents.png" alt="" />
        </div>
        <!-- 词法/句法切换按钮 -->
        <div class="toggle-container">
          <div class="my-switch" :class="{ 'is-checked': modelValue }" @click="toggleSwitch">
            <span
              class="my-switch__label my-switch__label--left"
              :class="{ 'is-active': !modelValue }"
            >
            </span>
            <div class="my-switch__core">
              <div :class="{ 'current-switch': !modelValue }">{{ inactiveText }}</div>
              <div :class="{ 'current-switch': modelValue }">{{ activeText }}</div>
              <span class="my-switch__button"></span>
            </div>
          </div>
        </div>
      </div>
      <img class="page-title-shadow" src="@/assets/grammar/divider-line.png" alt="" />

      <div class="back-btn" @click="backHome">
        <span>返回首页</span>
        <img class="icon-back" src="@/assets/grammar/icon-home.svg" alt="" />
      </div>

      <!-- 目录列表 -->
      <div class="grammar-list">
        <div
          v-for="(item, index) in grammarItems"
          :key="index"
          class="grammar-item"
          :class="{ expanded: item.expanded, 'border-top': index !== 0 }"
        >
          <div class="grammar-item_header">
            <ion-label>{{ item.chapterName }}</ion-label>
            <img
              class="arrow-icon"
              :class="{ 'transform-rotate': !item.expanded }"
              src="@/assets/grammar/arrow_top.png"
              @click="toggleItem(item, index)"
            />
          </div>

          <!-- 展开的子项 - 特别处理1.5形容词&副词 -->
          <div v-if="item.expanded" class="sub-items-container">
            <div class="detail-card">
              <img
                v-if="item.progress"
                class="progress-text"
                src="@/assets/grammar/icon-progress-text.svg"
                alt=""
                @click="toPrevProgress(item)"
              />
              <div
                v-if="item.attachmentList.length > 0"
                class="video-container"
                :class="{ 'video-pause': !isPlaying }"
              >
                <video ref="videoPlayer" controls="controls" @click="toggleVideo">
                  <source :src="item.attachmentList[0].url" type="video/mp4" />
                </video>
                <div v-if="!isPlaying" class="play-button" @click="toggleVideo">
                  <img src="@/assets/grammar/video_poster.png" alt="" />
                </div>
              </div>
              <!-- 子目录项 -->
              <div class="sub-list">
                <div
                  v-for="(subItem, subIndex) in item.subChapterInfoList"
                  :key="subIndex"
                  class="sub-item"
                  :class="{ 'border-top': subIndex !== 0 }"
                  @click="toggleSubItem(item, subItem)"
                >
                  <ion-label>{{ subItem.subsectionName }}</ion-label>
                  <img class="arrow-icon arrow-right" src="@/assets/grammar/arrow_top.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { defineComponent, ref, reactive, computed, onMounted, defineProps } from "vue";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonSegment,
  IonSegmentButton,
  IonIcon,
  IonButtons,
  IonBackButton,
  modalController,
} from "@ionic/vue";
import { chevronDown, chevronUp, playCircle } from "ionicons/icons";
import http from "@/js/http";
import GrammarIndex from "@/views/grammar/newGrammar/Index.vue";
import store from "@/js/store";

const isPlaying = ref(false);
const videoPlayer = ref(null);
const modelValue = ref(false);
const activeText = ref("句法");
const inactiveText = ref("词法");

const props = defineProps(["courseId"]);

const isPrepare = reactive(sessionStorage.getItem("isPrepare"));

// 目录数据
const grammarItems = ref([]);

const backHome = async () => {
  location.replace("/TeacherIndex");
};

const toggleSwitch = () => {
  modelValue.value = !modelValue.value;
  getMenuList();
};

// 计算当前展开的项
const expandedItem = computed(() => {
  return grammarItems.value.find((item) => item.expanded);
});

// 切换主目录项展开/折叠
const toggleItem = (item, idx) => {
  // 如果点击的是已展开的项，则不做任何操作
  grammarItems.value[idx]["expanded"] = !grammarItems.value[idx]["expanded"];

  ///陪练备课状态下不调api
  if(grammarItems.value[idx]["expanded"] && !isPrepare){
    getRecord(item,idx)
  }
};

//获取学习进度
const getRecord = function (item,idx) {
  const aptmId = store.getAppointment().aptmId;
  http
    .post("/chapter/subchapter/getLearningProgress", {
      aptmId: aptmId,
      chapterId: item.chapterId,
    })
    .then((res) => {
      if (res.data.code === 200) {
        if( res.data.data){
          grammarItems.value[idx]["progress"] = res.data.data
        }
      }
    });
};

const toPrevProgress = function(item) {
  toggleSubItem(item,{subChapterId:item.progress})
}

// 展示内容页
const toggleSubItem = async (item, subItem) => {
  grammarItems.value.forEach((item) => {
    item.expanded = false;
  })
  const modal = await modalController.create({
    component: GrammarIndex,
    componentProps: { chapterId: item.chapterId, subChapterId: subItem.subChapterId },
    cssClass: "modal_controller_class",
  });
  return modal.present();
};

// 切换视频播放/暂停
const toggleVideo = () => {
  if (videoPlayer.value) {
    if (isPlaying.value) {
      videoPlayer.value[0].pause();
    } else {
      videoPlayer.value[0].play();
    }
    isPlaying.value = !isPlaying.value;
  }
};

//获取目录
const getMenuList = async () => {
  try {
    const chapterType = modelValue.value ? 1 : 0;
    const { data } = await http.get(
      `/chapter/chapter/getChapterInfo?courseId=${props.courseId}&chapterType=${chapterType}`
    );
    if (data.code === 200) {
      if (data.data.length > 0) {
        grammarItems.value = data.data;
        for (const item of grammarItems.value) {
          item.expanded = false;
        }
      } else {
        grammarItems.value = [];
      }
    }
  } catch (e) {}
};
onMounted(() => {
  getMenuList();
});
</script>

<style scoped lang="less">
.directory-page {
  background-color: #055c49;

  .header {
    padding: 1rem 1rem 0;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    position: relative;
  }
}

.title-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 0;
  text-align: left;

  .page-title {
    font-size: 2.6rem;
    color: #ffffff;
    font-weight: 600;
    position: relative;
    z-index: 2;
  }

  .page-title-shadow {
    width: 8.5rem;
    margin-top: -1rem;
    position: relative;
    z-index: 1;
    margin-left: 0.3rem;
  }
}

.title-image {
  height: 40px;
}

.toggle-container {
  margin: 15px 0;

  .my-switch {
    display: inline-flex;
    align-items: center;
    position: relative;
    font-size: 0.9rem;
    vertical-align: middle;
    cursor: pointer;
  }

  .my-switch__label.is-active {
    color: #0dcb8b;
  }

  .my-switch__core {
    display: flex;
    position: relative;
    width: 7rem;
    height: 2.2rem;
    border-radius: 3rem;
    background-color: #ffffff33;
    transition: all 0.3s;
    vertical-align: middle;
    color: #ffffff;

    & > div {
      width: 50%;
      text-align: center;
      line-height: 2.1rem;
      position: relative;
      z-index: 10;
    }

    .current-switch {
      color: #0dcb8b;
    }
  }

  .my-switch.is-checked .my-switch__core {
    background: #ffffff33;
  }

  .my-switch__button {
    position: absolute;
    top: 0.1rem;
    left: 0.1rem;
    border-radius: 3rem;
    width: 3.5rem;
    height: 2rem;
    background: #cff5e8;
    transition: transform 0.3s;
    z-index: 9;
  }

  .my-switch.is-checked .my-switch__button {
    transform: translateX(3.3rem);
  }
}

.segment-button {
  --color: #ffffff;
  --color-checked: #ffffff;
  --background-checked: linear-gradient(0deg, #ffffff, #ffffff),
    linear-gradient(0deg, rgba(13, 203, 139, 0.2), rgba(13, 203, 139, 0.2));
}

ion-segment {
  --background: #e0f2f1;
  border-radius: 20px;
  overflow: hidden;
}

.back-btn {
  width: 6.5rem;
  height: 2rem;
  background-color: #4b897c;
  color: white;
  text-align: center;
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
  margin-top: 0.6rem;
  font-size: 0.9rem;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .icon-back {
    width: 0.87rem;
    height: 0.87rem;
    margin-left: 0.3rem;
  }
}

.grammar-list {
  padding: 0 0.8rem 0.8rem;
  color: #ffffff;
  display: flex;
  flex-direction: column;
}

.grammar-item {
  font-size: 1.08rem;
  font-weight: 500;
  padding: 1.2rem 0;

  &_header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .transform-rotate {
      transform: rotate(180deg);
      transition: transform 0.3s;
    }
  }

  .progress-text {
    width: 4.7rem;
    margin-left: 0.3rem;
  }
}

.arrow-icon {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background-color: #ffffff;
  transition: transform 0.3s;
}

.arrow-right {
  transform: rotate(90deg);
}

.border-top {
  border-top: 1px solid #0000001a;
}

.sub-items-container {
  border-radius: 10px;
}

.detail-card {
  width: 100%;
  background-color: #ffffff33;
  border-radius: 0.5rem;
  padding: 1rem 0.8rem;
  position: relative;
  margin-top: 1rem;
}

.video-container {
  position: relative;
  width: 100%;
  height: 11rem;
  overflow: hidden;
}

.video-pause {
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #0000004d;
    z-index: 2;
  }
}

video {
  width: 100%;
  height: 11rem;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
  z-index: 3;
  width: 2.2rem;
}

.sub-list {
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
}

.sub-item {
  --background: #00796b;
  --color: #ffffff;
  font-size: 1.08rem;
  padding: 1.2rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.sub-item:last-child {
  margin-bottom: 0;
}
</style>
